export default (state,street,city,zip) => {
    return `${street}, ${city} ${state}`
}